<template>
    <div>
        <div>Dashboard</div>

        <div>
            <router-link to="/auth/logout">logout</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dashboard', // eslint-disable-line vue/multi-word-component-names
};
</script>
